module.exports = __webpack_public_path__ + "img/title1.21796c76.png";